import type { IconName } from "../ui/icon";

// One icon for each entry of the menu, keyed by the `key` of the entry in `offering.ts`. The icon is decoration: the label is always
// in the markup (visible, or `sr-only` when the sidebar is collapsed). The role rules stay in `offering.ts`; this file only draws.

export const navIcons: Readonly<Record<string, IconName>> = {
  home: "home-01",
  concierge: "bubble-chat",
  customers: "user-group",
  privacy: "security-check",
  requests: "task-01",
  coverage: "calendar-03",
  trips: "airplane-02",
  actions: "checkmark-square-02",
  payments: "credit-card",
  catalog: "location-01",
  imports: "file-import",
  analytics: "analytics-up",
  operations: "dashboard-speed-01",
  staff: "user-settings-01",
};

/** The icon of a menu entry. An entry without an icon gets a neutral one, so a new area never breaks the menu. */
export function navIconFor(key: string): IconName {
  return navIcons[key] ?? "checkmark-square-02";
}
